export const apiNx = () => {
    return "/api/nx"
}
